<template>
  <CountryPage country="israel" />
</template>